// Client für die Weblog-Requestkarte unter /monitor.
// Gleiche Konventionen wie vacuum.js: nginx-Proxy /api (Heimnetz-only),
// siehe FastAPI-Docs unter /docs auf dem Backend.

import { req } from './vacuum'

const BASE_URL = '/api'

export const weblogApi = {
  baseUrl: BASE_URL,

  // Kartenpunkte. hours muss 1, 24, 168 oder 720 sein — das Backend antwortet
  // sonst 400. Die größeren Fenster aggregieren im Backend deutlich mehr Zeilen,
  // daher der größere Timeout.
  map: (hours = 24, includeLocal = false) =>
    req(`/weblog/map?hours=${hours}&include_local=${includeLocal}`, { timeout: 20000 }),

  // Nutzungsstatistik des Fensters. Kein include_local: die Antwort zählt immer
  // alles und weist Heimnetz/extern getrennt aus (siehe /docs).
  // Der Timeout ist absichtlich groß: das 30-Tage-Fenster liest in vier
  // Aggregationen 1,47 Mio Zeilen und brauchte kalt gemessen 18,6 s. Danach
  // liefert der Backend-Cache 10 Minuten lang sofort — der Wert deckt also nur
  // den ersten Aufruf nach einem Neustart oder Cache-Ablauf ab.
  stats: (hours = 24) =>
    req(`/weblog/stats?hours=${hours}`, { timeout: 40000 }),

  // Detail zu einer IP. 404 (als Error) wenn im Fenster keine Requests vorliegen.
  // Höherer Timeout als map(), obwohl map() mehr Zeilen aggregiert: dieser
  // Endpoint fährt fünf Aggregationen über die Zeilen einer einzelnen Adresse
  // (Status/URI/User-Agent-Gruppierung, Seite, Geo-Lookup), und allein die
  // gruppierte Status-Query maß 1241 ms auf der Traffic-stärksten Adresse
  // (10.10.0.4, 7-Tage-Fenster) — die ganze Methode 1,8 s. Mit dem Default von
  // 8000 ms (req()) kann das beim schwersten Fall plausibel abbrechen, und der
  // Abbruch zeigt dann nur "Details konnten nicht geladen werden" ohne Hinweis
  // auf ein Timeout.
  // `status` filtert nur die Requestliste (Code wie "500" oder "unknown"); die
  // Kopfdaten und status_counts bleiben ungefiltert, siehe /docs.
  ip: (ip, hours = 24, limit = 50, offset = 0, status = null) =>
    req(`/weblog/ip/${encodeURIComponent(ip)}?hours=${hours}&limit=${limit}&offset=${offset}`
        + (status ? `&status=${encodeURIComponent(status)}` : ''),
        { timeout: 30000 }),
}
